module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./node_modules/entities/maps/xml.json
// module id = 237
// module chunks = 0 1 2 4 5 6 7 13 14 15 16 22